import { defineComponent } from "../../../common/runtime/defineComponent.svelte.ts";
import { errorSlotName, hintSlotName } from "../../../common/components/action/slotNames";
import { ensureId } from "../../../common/components/action/utils/ensureId";

/*                                                                                       */
const getActionElement = (host: HTMLElement): HTMLElement | undefined =>
  Array.from(host.children).find((child): child is HTMLElement => child.slot === "");

/*                                                                                                 */
const getSlotIds = (host: HTMLElement, slotName: string): string[] =>
  Array.from(host.querySelectorAll<HTMLElement>(`[slot="${slotName}"]`), ensureId);

defineComponent({
  tag: "oc-checkbox-v2",
  extendOptions: { useOcAutoAriaLabel: true },
  styles: () => import("./CheckboxV2.global.scss?inline"),
  props: {
    labelPlacement: { attribute: "label-placement", reflect: true },
    widthBehavior: { attribute: "width-behavior", reflect: true },
    size: { reflect: true },
  },
  html: `<slot></slot><slot name="label"></slot><slot name="error" aria-hidden="true"></slot><slot name="hint" aria-hidden="true"></slot>`,
  /*                                                                                  */
  /*                                                                              */
  onMount: (host) => {
    const update = (): void => {
      const actionElement = getActionElement(host);
      if (!actionElement) return;

      const validationMessageIds = getSlotIds(host, errorSlotName);
      const hintIds = getSlotIds(host, hintSlotName);
      const ariaDescribedBy = [...validationMessageIds, ...hintIds].join(" ");

      if (ariaDescribedBy.length === 0) actionElement.removeAttribute("aria-describedby");
      else actionElement.setAttribute("aria-describedby", ariaDescribedBy);

      /*                                                   */
      if (validationMessageIds.length || !actionElement.ariaDescription) {
        actionElement.ariaInvalid = validationMessageIds.length > 0 ? "true" : null;
      }
    };

    update();

    const observer = new MutationObserver(update);
    observer.observe(host, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["slot", "id"],
    });

    return () => observer.disconnect();
  },
});
